import { Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { CircularLoader } from '@HomaHealth/ui-component-library';
import {
  BasicTable,
  Button,
  CardComponent,
  ChipSelect,
  Columns,
  Download,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import React, { useState } from 'react';
import { scrollBarStyles } from '../../../core-utils/messages/CommonConstants';
import {
  handleHeaderMouseEnter,
  handleHeaderMouseLeave,
} from '../../../core-utils/helper-utils/tableSortHelper';
import { Pagination } from '@mui/material';
import { DynamicFilter } from '../../molecules/DynamicFilter';

export interface CustomColumnsTableProps {
  title: string | React.JSX.Element;
  subTitle?: string | React.JSX.Element;
  isCollapsiblePatientTable?: boolean;
  //Dropdown props
  options: string[];
  mandateOptions?: string[];
  anyOneMandate?: string[];
  selectedItems: string[];
  setSelectedItems: React.Dispatch<React.SetStateAction<string[]>>;
  handleChangeColumns: () => void;
  handleExport?: () => void;

  //Table props
  columns: Columns[];
  rowsData: any[];
   
  handleMemberClick?: (memberId: string) => void;
  totalPages: number;
   
  handlePageChange: (event: React.ChangeEvent<unknown>, page: number) => void;
  pageNumber: number;
  tableLoading: boolean;
  handleSort?: any;
  isFilter?: boolean;
  onFilterOpen?: () => void;
  filterOptions?: {
    label: string;
    options: string[];
    selected: string | null;
     
    onChange: (value: string) => void;
  }[];
}

const useStyles = makeStyles()({
  buttons: {
    display: 'flex',
    alignItems: 'center',
    gap: '24px',
    marginTop: '12px',
  },
  loader: {
    minHeight: '500px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  tableGrid: {
    marginTop: '11px',
    overflowX: 'auto',
    width: '1130px',
    ...scrollBarStyles,
  },
});

const CustomColumnsTable: React.FC<CustomColumnsTableProps> = ({
  title,
  subTitle,
  isCollapsiblePatientTable = true,
  options,
  columns,
  rowsData,
  handleMemberClick,
  totalPages,
  handlePageChange,
  pageNumber,
  selectedItems,
  setSelectedItems,
  tableLoading,
  handleChangeColumns,
  handleExport,
  mandateOptions,
  handleSort,
  anyOneMandate,
  filterOptions,
  isFilter = false,
  onFilterOpen,
}) => {
  const { classes } = useStyles();
  const [columnId, setColumnId] = useState<string>();

  return (
    <CardComponent
      title={title}
      subTitle={subTitle}
      width="1176px"
      topRightItem={
        <Grid className={classes.buttons}>
          <ChipSelect
            placeholder={'Add Column'}
            options={options}
            selectedItems={selectedItems}
            setSelectedItems={setSelectedItems}
            handleAddColumns={handleChangeColumns}
            {...(anyOneMandate
              ? { anyOneMandate: anyOneMandate }
              : { mandateOptions: mandateOptions })}
          />
          <Button
            variant="outlined"
            label={'Export CSV'}
            startIcon={
              <Download strokeWidth={1} width={'20px'} height={'20px'} />
            }
            color="primary"
            width="134px"
            height="36px"
            borderRadius="4px"
            onClick={handleExport}
          />
          {isFilter && (
            <Grid
              onClick={() => {
                onFilterOpen?.(); // ✅ RESET FILTERS HERE
              }}
            >
              <DynamicFilter
                filterOptions={(filterOptions || []).map((f) => ({
                  ...f,
                  selected: f.selected || '',
                }))}
              />
            </Grid>
          )}
        </Grid>
      }
      body={
        tableLoading ? (
          <Grid className={classes.loader}>
            <CircularLoader />
          </Grid>
        ) : (
          <Grid className={classes.tableGrid}>
            <Grid
              style={{
                width:
                  columns?.length > 4 ? `${columns?.length * 282}px` : '1130px',
              }}
            >
              <BasicTable
                isCollapsiblePatientTable={isCollapsiblePatientTable}
                columns={columns}
                rowsData={rowsData}
                isFullTable
                headerCellHeight="46px"
                getMemberId={handleMemberClick ?? (() => { })}
                showOnHoverHeader={true}
                columnId={columnId}
                handleHeaderMouseEnter={(column: any) =>
                  handleHeaderMouseEnter(column, setColumnId)
                }
                handleHeaderMouseLeave={() =>
                  handleHeaderMouseLeave(setColumnId)
                }
                handleMenuItem={handleSort}
                showPagination={false}
                handleOnClick={() => {}}
              // pageCount={totalPages}
              // handlePagination={handlePageChange}
              // pageNumber={pageNumber}
              />
            </Grid>
            <Pagination
              page={pageNumber}
              count={totalPages}
              onChange={handlePageChange}
              size="small"
              color="primary"
              style={{
                margin: '20px 0px',
              }}
            />
          </Grid>
        )
      }
    />
  );
};

export default CustomColumnsTable;
